import cx from "classnames";

import { getPastelColor } from "common/utils/colors";
import { fromISODateTime, toLocaleDate, toTime } from "common/utils/dates";

import { ClientAppointment } from "../types";

import styles from "../styles/AppointmentBookingAppointment.module.less";

type AppointmentBookingAppointmentProps = {
  appoinment: ClientAppointment;
};

const AppointmentBookingAppointment = ({ appoinment }: AppointmentBookingAppointmentProps) => {
  const start = fromISODateTime(appoinment.start_datetime);

  return (
    <div>
      <div className={cx(styles.appointment, styles[getPastelColor(appoinment.kind?.color)])}>
        <div>
          <div className={styles.name}>{appoinment.patient.name_display}</div>
          {appoinment.kind && <div className={styles.kind}>{appoinment.kind.label}</div>}
          <div className={styles.details}>
            {[
              toLocaleDate(start, { month: "short", day: "numeric" }),
              toTime(start),
              appoinment.resource?.name,
            ].join(" · ")}
          </div>
        </div>
        <div>
          <div className={styles.month}>{toLocaleDate(start, { month: "short" })}</div>
          <div className={styles.day}>{toLocaleDate(start, { day: "numeric" })}</div>
        </div>
      </div>
      <div className={styles.reason}>{appoinment.reason}</div>
    </div>
  );
};

export default AppointmentBookingAppointment;
